/* eslint-disable import/prefer-default-export */

export { default as ContainerActionsBar } from './ContainerActionsBarConnector';
